export default __webpack_public_path__ + "static/media/app-bar-save.41367d13.svg";